import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { TRIAL_STAFF_TYPE_ENUM, USER_TYPES, UserTypes } from '../../Types'
import { analytics } from '../../util/analytics'

type Props = {
  userType: UserTypes
  staffType?: TRIAL_STAFF_TYPE_ENUM
}

export const HideEdit = ({ userType, staffType }: Props) => {
  const trackEditAccessClick = () => {
    analytics.track('CLICK_EDIT_SITE_ACCESS')
  }

  const trackEditInformationClick = () => {
    analytics.track('CLICK_EDIT_INFORMATION')
  }

  return (
    <>
      {userType === USER_TYPES.CTM ? (
        <>
          {staffType === TRIAL_STAFF_TYPE_ENUM.CRA ? (
            <Link to="sites" onClick={trackEditAccessClick}>
              <Button className="me-3" type="primary">
                Edit site access
              </Button>
            </Link>
          ) : null}

          <Link to="edit" onClick={trackEditInformationClick}>
            <Button type="primary">Edit information</Button>
          </Link>
        </>
      ) : (
        <></>
      )}
    </>
  )
}
